import { render, staticRenderFns } from "./activity-log.vue?vue&type=template&id=47a5678f&scoped=true&"
import script from "./activity-log.vue?vue&type=script&lang=js&"
export * from "./activity-log.vue?vue&type=script&lang=js&"
import style0 from "./activity-log.vue?vue&type=style&index=0&id=47a5678f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47a5678f",
  null
  
)

export default component.exports